import { IProperty } from "@/types/properties";
import TitleWithValue from "../title-with-value";
import { useTranslation } from "react-i18next";

type Props = {
  item: IProperty;
};
export default function Symbol({ item }: Props) {
  const { t } = useTranslation(["common"]);
  return (
    <TitleWithValue
      colorTitle="grey.400"
      colorValue="black"
      variantTitle="extraSmallRegular"
      variantValue="extraSmallLight"
      direction={"row"}
      title={t("common:symbol_property")}
      value={item?.symbol_fa ? item?.symbol_fa : "-"}
      sxProps={{
        borderBottom:"none !important",
        padding: 1,
      }}
    />
  );
}
